import styled from 'styled-components';

import { BLACK, WHITE, BG_GRAY } from '@/styles/variables.style';
import media from '../../../styles/media.style';

export const Section = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  ${media.tabletL`
    display: flex;
  `};
`;

export const ColumnOne = styled.div`
  height: 50%;
  width: 100%;

  ${media.tabletL`
    height: 100%;
    width: 50%;
  `};
`;

export const ColumnTwo = styled.div`
  height: 50%;
  width: 100%;

  ${media.tabletL`
    height: 100%;
    width: 50%;
  `};
`;

export const FirstImageWrapper = styled.div`
  height: 36%;
`;

export const FirstToutWrapper = styled.div`
  height: 15%;
`;

export const SecondImageWrapper = styled.div`
  height: 34%;
`;

export const SecontToutWrapper = styled.div`
  height: 15%;
`;

export const ThirdImageWrapper = styled.div`
  height: 51%;
`;

export const ThirdToutWrapper = styled.div`
  height: 15%;
`;

export const ArticleContents = styled.div`
  width: 100%;
  height: 17%;

  &.placeholder {
    height: 34%;
  }

  /* 各リンク */
  div {
    float: left;
  }

  div:nth-child(3n) {
    clear: both;
  }
`;

export const Arrow = styled.div`
  width: 8px;
  height: 8px;
  border-top: 1px solid ${WHITE};
  border-right: 1px solid ${WHITE};
  transform: rotate(45deg);
`;

export const ArticleContent = styled.div`
  width: 50%;
  height: 100%;
  overflow: hidden;

  &.linkNonHolder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${BG_GRAY.COMMON_1};
  }

  &.linkHolder {
    position: relative;
  }
`;

export const ArticleContentImage = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const ArticleContentNameWrapper = styled.div`
  position: absolute;
  z-index: 99;
  bottom: 0;
  width: 100%;
  height: 20%;
  padding: 8px 0;
  text-align: center;
  text-transform: uppercase;
  font-size: 13px;
  color: ${WHITE};

  &.linkHolder {
    background: rgba(0, 0, 0, 0.6);
  }

  ${media.tabletL`
    font-size: 16px;
    height: 22%;
  `};
`;

export const ArticleContentNameAndArrow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ArticleContentName = styled.div`
  margin: 0;

  // デザイン調整のため、ブレイクポイントを 3 つ設定
  &.linkNonHolderContent {
    color: ${BLACK};
    font-size: 16px;
    font-weight: 600;

    ${media.tabletP`
      // リキッド対応のため単位を vw で設定。
      font-size: 3.4vw;
    `};

    ${media.tabletL`
      top: 10px;
      // リキッド対応のため単位を vw で設定。
      font-size: 2.2vw;
    `};

    ${media.desktop`
      font-size: 30px;
    `};
  }

  &.linkNonHolderAuthor {
    position: unset;
    top: 20px;
    color: ${BLACK};
    font-size: 10px;
    text-align: center;

    ${media.tabletL`
      top: 20px;
      font-size: 16px;
    `};
  }

  &.linkHolder {
    margin: 2px 0 0;
    cursor: pointer;
  }
`;

export const Linker = styled.a`
  text-decoration: none;

  &:focus {
    outline: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomeTouts/HomeTouts.style.js